import React, { useEffect } from 'react';
import { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

// firebase
import {
    getAuthUser,
    addToCart,
    removeFromCart,
    updateAuthUser,
    handleProductDetails,
    getBillNumber,
    getSubscriptionDetails,
    handleUserExist
} from '../../Redux/actions';
import {
    handle_auth_user,
    handle_product_details,
    handle_activePage,
} from '../../Redux/reducer';

import PayButton from '../Payment/Frontend/App'
import getSymbolFromCurrency from 'currency-symbol-map';

import EditIcon from '@material-ui/icons/Edit';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import RemoveShoppingCartIcon from '@material-ui/icons/RemoveShoppingCart';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';

// Illustrations
import emptyCart from '../../assets/Empty cart.png';

const Payment = () => {
    
    const dispatch = useDispatch();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const productDetails = useSelector((state) => state.auth.productDetails);
    const amountPayable = useSelector((state) => state.auth.amountPayable);
    const user = useSelector((state) => state.auth.user);
    const subscriptions = useSelector((state) => state.auth.subscriptions);

    const [dense, setDense] = useState(false);
    const [secondary, setSecondary] = useState(false);
    const [makePayment, setMakePayment] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    // const [totalAmount, setTotalAmount] = useState(0);
    // Object.keys(productDetails).map(function(key) {
    //     setTotalAmount(totalAmount + productDetails[key].total);
    //     console.log("Payment:totalAmount",totalAmount);
    // })
    
    // References
    const firstNameRef = useRef();
    const lastNameRef = useRef();
    const phoneNumberRef = useRef();
    const emailRef = useRef();
    const addressRef = useRef();
    const productRef = useRef();
    const planRef = useRef();
    const monthRef = useRef();
    // const paymentModeRef = useRef();

    // useEffect(
    //   () => {
    //     dispatch(getSubscriptionDetails(user.email, "Hi"));
    //   },
    //   [1],
    // );

    // useEffect(
    //     () => {
    //         // console.log("lohith:Navbar:useEffect: outside if 1 : activePage = ", activePage);
    //         dispatch(getBillNumber("receipt"));
    //     },
    //     [1],
    // );

    const handleIsEdit = () => {
        // e.preventDefault();
        setIsEdit(!isEdit);
    }

    const handleUpdateUserDetails = () => {
        // console.log("Payment:handleUpdateUserDetails");

        const updateUser = {
            uid: user.uid,
            fullName: firstNameRef.current.value +" "+ lastNameRef.current.value,
            firstName: firstNameRef.current.value,
            lastName: lastNameRef.current.value,
            email: emailRef.current.value,
            mobile: phoneNumberRef.current.value,
            address: addressRef.current.value,
        };
        
        if(user.name 
            || updateUser.fullName !== user.fullName
            || updateUser.firstName !== user.firstName
            || updateUser.lastName !== user.lastName
            || updateUser.email !== user.email
            || updateUser.mobile !== user.mobile
            || updateUser.address !== user.address
        ){
            // console.log("Lohith:Payment:handleUpdateUserDetails: user, updateUser = ", user, updateUser, updateUser === user, updateUser !== user, updateUser == user, updateUser != user);
            dispatch(updateAuthUser(updateUser));
        } else {
            window.alert("No changes were made to update the Basic Details");
            // console.log("Lohith:Payment:handleUpdateUserDetails: No change to updateUser = ", user, updateUser, updateUser === user, updateUser !== user, updateUser == user, updateUser != user);
        }  
        setTimeout(() => {
            handleIsEdit()
        }, 1000);
    }

    const handleCalculate = () => {
        // console.log("Payment:handleCalculate:paymentDetails,user", productDetails,user);
        var amount;
        if(productRef.current.value == 'Hi')
        {
            amount = 400;
        } else if(productRef.current.value == 'HiLite'){
            amount = 300;
        } else if(productRef.current.value == 'HiRender'){
            amount = 1000;
        }
        const total_noGST = amount * monthRef.current.value;
        const total_addGST = (total_noGST) + (((total_noGST) / 100) * 18);

        const newProduct = {}
        newProduct[productRef.current.value] = {
            name: productRef.current.value,
            plan: planRef.current.value,
            month: monthRef.current.value,
            amount: amount,
            total: total_noGST,
        };

        dispatch(handleProductDetails(emailRef.current.value,productDetails,newProduct));

    }

    // Update User Details 
    const handleUserDetailsEdit = (e) => {
        e.preventDefault();
        if (
        firstNameRef.current.value != "" 
        && lastNameRef.current.value != "" 
        && emailRef.current.value != "" 
        && phoneNumberRef.current.value  != "" 
        && addressRef.current.value  != "" 
        ) {
            // console.log("Lohith:Payment:handleUserDetailsEdit")
            handleUpdateUserDetails()
            // if(Object.keys(subscriptions).length == 0){
            //     handleCalculate()
            // } else {
            //     window.alert("Subscriptions exist! Valid till: "+ subscriptions.Hi.to_date);
            // }
        } else {
            window.alert("Please fill all the fields in Basic Details");
            // console.log("Payment:handleUserDetailsEdit: Please fill all the fields");
            // console.log("Payment:handleProductAdd:paymentDetails2", productDetails,user);
        }
    };

    //Add Cart Function
    const handleProductAdd = (e) => {
        e.preventDefault();
        if( firstNameRef.current.value != "" 
        && lastNameRef.current.value != "" 
        && emailRef.current.value != "" 
        && phoneNumberRef.current.value  != "" 
        && addressRef.current.value  != ""
        ){
            if ( productRef.current.value  != "" 
            && planRef.current.value  != "" 
            && monthRef.current.value  != "" 
            ) {
                // console.log("Lohith:Payment:handleProductAdd:subscriptions",subscriptions, productRef.current.value)
                if(Object.keys(subscriptions).length == 0){
                    handleCalculate()
                } else {
                    window.alert("Subscriptions exist! Valid till: "+ subscriptions.Hi.to_date);
                    handleCalculate()
                }
            } else {
                // console.log("Payment:handleProductAdd: Please fill all the fields");
                window.alert("Please fill all the fields in Add Product")
                // console.log("Payment:handleProductAdd:paymentDetails2", productDetails,user);
            }
        } else {
            window.alert("Please fill all the fields in Basic Details");
        }
        
    };

    //Add Cart Function
    const handleRemoveCart = (e) => {
        e.preventDefault();
        dispatch(removeFromCart(user.email))
    };

//   //Payment Final Function
//   const handlePaymentSubmit = (e) => {
//     e.preventDefault();
//     if ( paymentModeRef.current.value  != "" ) {
//         setMakePayment(true);
//     } else {
//         console.log("Payment:handlePaymentSubmit: Please fill all the fields");
//     }
//   };

    //Payment on enter-press
    const enterMessageUsPressed = (event) => {
        var code = event.keyCode || event.which;
        if (code === 13) {
            handleProductAdd(event);
            // handlePaymentSubmit(event);
        //13 is the enter keycode
        //Do stuff in here
        }
    };

    return(
        <div>
            {/* <h1 className='payment-page-title' >Make Payment</h1> */}
            <div className='payment-section'>
                <div className='payment-section-user-info'>
                    <form 
                        // onSubmit={handleProductAdd} 
                        // onKeyPress={enterMessageUsPressed}
                        className='payment-user-form'
                    >
                        <div style={{width:"100%"}}>
                            <label className='payment-user-form-label' >Basic Details</label>
                            {isEdit 
                            ? <>
                                <div className='closeIcon' onClick={handleIsEdit}>
                                    <CloseIcon />
                                </div>
                                <div className='saveIcon' onClick={handleUserDetailsEdit}>
                                    <SaveIcon />
                                </div>
                            </>
                            :<>
                            {Object.keys(user).length > 0 
                            ? <div className='editIcon' onClick={handleIsEdit}>
                                <EditIcon /> 
                            </div>
                            :<div className='saveIcon' onClick={handleUserDetailsEdit}>
                                <SaveIcon />
                            </div>}
                            </>}
                        </div>
                        <br/>
                        {isEdit ?
                        <div>
                            <div className='payment-user-form-fields'>
                                <input 
                                    className='payment-firstname' 
                                    // placeholder="First name"
                                    placeholder={user.firstName ? user.firstName : user.name ? user.name : "First name"}
                                    type="text"
                                    autoFocus
                                    required
                                    ref={firstNameRef}
                                    // value={user.firstName ? user.firstName : user.name}
                                /><br></br>
                                <input 
                                    className='payment-lastname' 
                                    placeholder={user.lastName ? user.lastName : "Last name"}
                                    type="text"
                                    required
                                    ref={lastNameRef}
                                    // value={user.lastName}
                                /><br></br>
                            </div>
                            <div className='payment-user-form-fields'>
                                <input 
                                    className='payment-phoneNumber' 
                                    placeholder={user.mobile ? user.mobile : "Phone Number"} 
                                    type="mobile"
                                    required
                                    ref={phoneNumberRef}
                                    // value={user.mobile}
                                /><br></br>
                                <input 
                                    className='payment-email' 
                                    placeholder={user.email ? user.email : "Email ID"} 
                                    type="email"
                                    required
                                    ref={emailRef}
                                    // value={user.email}
                                /><br></br>
                            </div>
                            <div className='payment-user-form-fields'>
                                <input 
                                    className='payment-address' 
                                    placeholder={user.address ? user.address : "Address"} 
                                    type="address"
                                    required
                                    ref={addressRef}
                                    // value={user.address}
                                /><br></br>
                            </div>
                        </div>
                        : <div style={{pointerEvents:"none"}}>
                            <div className='payment-user-form-fields'>
                                <input 
                                    className='payment-firstname' 
                                    placeholder="First name"
                                    type="text"
                                    // autoFocus
                                    required
                                    ref={firstNameRef}
                                    value={user.firstName ? user.firstName : user.name}
                                /><br></br>
                                <input 
                                    className='payment-lastname' 
                                    placeholder="Last name"
                                    type="text"
                                    required
                                    ref={lastNameRef}
                                    value={user.lastName}
                                /><br></br>
                            </div>
                            <div className='payment-user-form-fields'>
                                <input 
                                    className='payment-phoneNumber' 
                                    placeholder="Phone Number" 
                                    type="mobile"
                                    required
                                    ref={phoneNumberRef}
                                    value={user.mobile}
                                /><br></br>
                                <input 
                                    className='payment-email' 
                                    placeholder="Email ID" 
                                    type="email"
                                    required
                                    ref={emailRef}
                                    value={user.email}
                                /><br></br>
                            </div>
                            <div className='payment-user-form-fields'>
                                <input 
                                    className='payment-address' 
                                    placeholder="Address" 
                                    type="address"
                                    required
                                    ref={addressRef}
                                    value={user.address}
                                /><br></br>
                            </div>
                        </div>}
                        
                        <br/>
                        <hr />
                        <br/>
                        
                        <div style={{width:"100%"}}>
                            <label className='payment-user-form-label' >Add Product</label>
                            {/* <div className='addIcon' onClick={handleProductAdd}>
                                <AddShoppingCartIcon />
                            </div> */}
                            {/* <button className='products-submit-btn' onClick={handleProductAdd}>Add</button> */}
                        </div>
                        <br/>
                        {/* <hr /> */}
                        <div className='payment-user-form-fields'>
                            <select name="products" id="products" className="products-name-list" ref={productRef}>
                                <option value="" disabled selected>Select Product</option>
                                <option className="products-list-hi" selected value="Hi">hi™</option>
                                <option className="products-list-hiLite" disabled value="HiLite">hilite™</option>
                                <option className="products-list-hiRender" disabled value="HiRender">hiRender™</option>
                            </select>
                            <select name="plans" id="plans" className="products-plan-list" ref={planRef}>
                                <option value="" disabled selected>Select Plans</option>
                                <option className="products-list-plans" selected value="Pro">Pro</option>
                                <option className="products-list-plans" disabled value="Bisness">Bisness</option>
                                <option className="products-list-plans" disabled value="Hour">Hourly</option>
                            </select>
                        {/* </div>
                        <div className='payment-user-form-fields'> */}
                            <select name="months" id="months" className="products-month-list" ref={monthRef}>
                                <option value="" disabled selected>Select months</option>
                                <option className="products-list-plans" value="1">Monthly</option>
                                <option className="products-list-plans" value="3">Quarterly</option>
                                <option className="products-list-plans" value="6">Half- Yearly</option>
                                <option className="products-list-plans" value="12">Annually</option>
                            </select>
                            {/* <select name="paymentMode" id="paymentMode" className="products-paymentMode-list" ref={paymentModeRef}>
                                <option value="" disabled selected>Select payment mode</option>
                                <option className="products-list-plans" value="card">Debit/Credit Card</option>
                                <option className="products-list-plans" value="upi">UPI</option>
                                <option className="products-list-plans" value="wallet">Wallet</option>
                                <option className="products-list-plans" value="netBanking">Net Banking</option>
                            </select> */}
                        </div>
                        {/* <br></br> */}
                    </form>
                    {/* {productDetails.length > 0 ? */}
                    <button className='products-submit-btn' onClick={handleProductAdd}>Add</button>
                    {/* :<button className='products-submit-btn' disabled>Add</button>} */}
                </div>
                <div className='payment-section-product-info'>
                    <form
                        onSubmit={handleProductAdd} 
                        onKeyPress={enterMessageUsPressed}
                    >
                        <div style={{width:"100%"}}>
                            <label className='payment-product-form-label' >Cart Details</label>
                            {/* <div className='cartIcon'>
                                {Object.keys(productDetails).length > 0 
                                ?<RemoveShoppingCartIcon onClick={handleRemoveCart} />
                                :<ShoppingCartIcon onClick={handleProductAdd} />}
                            </div> */}
                            {Object.keys(productDetails).length > 0
                            ? <div className='removeCartIcon' onClick={handleRemoveCart}>
                                <RemoveShoppingCartIcon />
                            </div>
                            : null
                            // <div className='cartIcon' onClick={handleProductAdd}>
                            //     <ShoppingCartIcon />
                            // </div>
                            }
                        </div>
                        <br></br>
                        <table className='payment-product-form-table'>
                            <tr className='payment-product-form-header'>
                                        {/* <td className='payment-product-form-data-cell' style={{width:"5%"}}></td> */}
                                <th className='payment-product-form-header-cell' style={{width:"23%"}}>Name</th>
                                <th className='payment-product-form-header-cell'>Plan</th>
                                <th className='payment-product-form-header-cell'>Prize</th>
                                <th className='payment-product-form-header-cell' style={{width:"17%"}}>Month</th>
                                <th className='payment-product-form-header-amount'>Amount</th>
                            </tr>
                            {Object.keys(productDetails).map(function(key) {
                                var product = productDetails[key];
                                // console.log("payment-product-form-data-cell:",key, product);
                                return(
                                    <tr className='payment-product-form-data'>
                                        {/* <td className='payment-product-form-data-cell' style={{width:"5%"}}><Delete className='productBin' fontSize='small'/></td> */}
                                        <td className='payment-product-form-data-cell' style={{width:"23%"}}>{product.name == 'Hi' ? 'hi™' : product.name == 'HiLite' ? 'hilite™' : 'hiRender™'}</td>
                                        <td className='payment-product-form-data-cell'>{product.plan}</td>
                                        <td className='payment-product-form-data-cell'>{getSymbolFromCurrency('INR')}{product.amount}</td>
                                        <td className='payment-product-form-data-cell' style={{width:"17%"}}>{product.month}</td>
                                        <td className='payment-product-form-data-amount'>{getSymbolFromCurrency('INR')}{product.total}</td>
                                    </tr>
                                )
                            })}
                            {/* {productDetails.map(function (key) {
                                return(
                                <tr className='payment-product-form-data'>
                                    <td className='payment-product-form-data-cell' style={{width:"23%"}}>{key.name == 'Hi' ? 'hi™' : key.name == 'HiLite' ? 'hilite™' : 'hiRender™'}</td>
                                    <td className='payment-product-form-data-cell'>{key.plan}</td>
                                    <td className='payment-product-form-data-cell'>{getSymbolFromCurrency('INR')}{key.amount}</td>
                                    <td className='payment-product-form-data-cell' style={{width:"17%"}}>{key.month}</td>
                                    <td className='payment-product-form-data-amount'>{getSymbolFromCurrency('INR')}{key.total}</td>
                                </tr>)
                            })} */}

                            {Object.keys(productDetails).length > 0 ? 
                            // {productDetails.length > 0 ? 
                            <>
                            {/* <tr className='payment-product-form-footer'>
                                <th className='payment-product-form-footer-label' colSpan={3}>Total =</th>
                                <th className='payment-product-form-footer-amount'>{getSymbolFromCurrency('INR')}{amountPayable}</th>
                            </tr>
                            <tr className='payment-product-form-footer'>
                                <th className='payment-product-form-footer-label'colSpan={3}>GST 18% =</th>
                                <th className='payment-product-form-footer-amount'>{getSymbolFromCurrency('INR')}{(amountPayable / 100) * 18}</th>
                            </tr> */}
                            <tr className='payment-product-form-footer'>
                                <th className='payment-product-form-footer-label'colSpan={3}>Amount Payable =</th>
                                <th className='payment-product-form-footer-amount'>{getSymbolFromCurrency('INR')}{amountPayable}</th>
                            </tr>
                            </>:<>
                            <tr className='payment-product-form-footer'>
                                <th className='payment-product-form-footer-label2'colSpan={5}>Your cart is empty! <br/>Please add a few items.</th>
                            </tr>
                            <img src={emptyCart} className='empty-cart-image' alt='emptyCart'/>
                            </>}
                        </table>
                        {/* { Object.keys(productDetails).length > 0 ? 
                            <select name="paymentMode" id="paymentMode" className="products-paymentMode-list" ref={paymentModeRef}>
                                <option value="" disabled selected>Select payment mode</option>
                                <option className="products-list-plans" value="card">Debit/Credit Card</option>
                                <option className="products-list-plans" value="upi">UPI</option>
                                <option className="products-list-plans" value="wallet">Wallet</option>
                                <option className="products-list-plans" value="netBanking">Net Banking</option>
                            </select> 
                        : null } */}
                        {/* { makePayment ? 
                            <PayButton />
                            :  Object.keys(productDetails).length > 0 ? 
                            <button className='payment-submit-btn' type={"submit"} onClick={handlePaymentSubmit} >Continue Payment</button> 
                            : null
                        } */}
                        { Object.keys(productDetails).length > 0 
                            ? isAuthenticated 
                                ? <PayButton /> 
                                : 
                                // <button 
                                //     className='payment-submit-btn' 
                                //     type={"submit"} 
                                //     onClick={dispatch(handleUserExist(user.email))} 
                                // >Continue Payment</button>
                                <Link   
                                    href="#contact" 
                                    to='/contact'
                                    onClick={()=>dispatch(handle_activePage("contact"))}
                                >
                                    <button className='payment-submit-btn'>Continue Payment</button>
                                </Link>
                            : null 
                        }
                        {/* { productDetails.length > 0 ? <PayButton /> : null } */}
                        {/* <PayButton /> */}
                    </form>
                </div> 
            </div>
        </div>
    )
}

export default Payment;
